import { createFileRoute } from "@tanstack/react-router";
import SecurityPolicyPage from "@/pages/security/SecurityPolicyPage";

export const Route = createFileRoute("/security/policy")({
  component: SecurityPolicyPage,
});
